<template>
  <div class="sem-data">
    <el-breadcrumb class="admin-path" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>数据维护</el-breadcrumb-item>
      <el-breadcrumb-item>SEM数据维护</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="container">
      <el-form :inline="true" :model="searchParams" class="search-form">
        <el-form-item label="Obs Time From">
          <el-date-picker
            size='mini'
            v-model="searchParams.startTime"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetime">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="Obs Time To">
          <el-date-picker
            size='mini'
            v-model="searchParams.endTime"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetime">
          </el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button size='mini' type="primary" @click="onSubmit">Search</el-button>
        </el-form-item>
        <el-form-item>
          <el-button size='mini'  @click="seminsert">新增</el-button>
        </el-form-item>
      </el-form>

      <el-table
        :data="list"
        style="width: 100%"
        align="center">
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column
          prop="ind"
          label="IND"
          v-if="false">
        </el-table-column>
        <el-table-column
          prop="sem_id"
          label="SEM_ID"
          width="150">
        </el-table-column>
        <el-table-column
          prop="date_utc"
          label="数据开始时间UTC">
        </el-table-column>
        <el-table-column
          prop="date_mjd"
          label="数据开始时间mjd">
        </el-table-column>
        <el-table-column
          prop="hxmt_day"
          label="观测天次"
          align="center"
          width="60">
        </el-table-column>
        <el-table-column
          prop="start_tt"
          label="数据开始时间tt">
        </el-table-column>
        <el-table-column
          prop="stop_tt"
          label="数据结束时间tt">
        </el-table-column>
        <el-table-column
          prop="duration"
          label="观测时长"
          width="100"
          align="center">
        </el-table-column>
        <el-table-column
          prop="status"
          label="数据状态"
          align="center"
          width="60">
        </el-table-column>
        <el-table-column
          prop="file_id"
          label="文件ID">
        </el-table-column>
        <el-table-column
          prop="release_date"
          label="数据发布时间">
        </el-table-column>

        <el-table-column
          width="100"
          label="操作">
          <template slot-scope="scope">
            <el-button
              class="copy-btn"
              :data-clipboard-text="scope.row"
              type="text"
              size="small"
              @click="semEdit(scope.row)">
              编辑
            </el-button>
            <el-button
              class="copy-btn"
              :data-clipboard-text="scope.row.ind"
              type="text"
              size="small"
              @click="semDelete(scope.row.ind)">
              删除
            </el-button>           
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="currentPage"
        :page-size.sync="pageSize"
        :total="total"
        @size-change="sizeChange"
        @current-change="changePage">
      </el-pagination>

      <el-dialog title="SEM数据新增" :visible.sync="semIsVisible" @close="closesemInsertDialog">
        <el-form :inline="true" :model="semForm" label-position="right">
          <el-form-item label="SEM_ID">
            <el-input v-model="semForm.sem_id" autocomplete="off" style="width:260px;"></el-input>
          </el-form-item>
          <el-form-item label="数据开始时间UTC">
            <el-date-picker v-model="semForm.date_utc" value-format="yyyy-MM-dd" format="yyyy-MM-dd" type="date" style="width:260px;"></el-date-picker>
          </el-form-item>
          <el-form-item label="观测天次">
            <el-input v-model="semForm.hxmt_day" autocomplete="off" style="width:260px;"></el-input>
          </el-form-item>
          <el-form-item label="数据开始时间mjd">
            <el-input v-model="semForm.date_mjd" autocomplete="off" style="width:220px;"></el-input>
          </el-form-item>
          <el-form-item label="观测时长">
            <el-input v-model="semForm.duration" autocomplete="off" style="width:260px;"></el-input>
          </el-form-item>
          <el-form-item label="数据开始时间(TT)">
            <el-input v-model="semForm.start_tt" autocomplete="off" ></el-input>
          </el-form-item>
          <el-form-item label="数据状态">
            <el-select style="width:260px;" v-model="semForm.status"  filterable placeholder="数据状态">
                  <el-option
                      v-for="item in status_list"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="数据结束时间tt">
            <el-input v-model="semForm.stop_tt" autocomplete="off" ></el-input>
          </el-form-item>        
          <el-form-item label="文件__ID">
            <el-input v-model="semForm.file_id" autocomplete="off" style="width:260px;"></el-input>
          </el-form-item>
          <el-form-item label="数据发布时间">
            <el-date-picker v-model="semForm.release_date" value-format="yyyy-MM-dd HH:mm:ss" type="datetime"></el-date-picker>
          </el-form-item>               
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="closesemInsertDialog">取消</el-button>
          <el-button type="primary" @click="confirmsemInsertDialog">确定</el-button>
        </div>
      </el-dialog>
      <SemEditDialog
        :dialog-visible="SemEditIsVisible"
        :dialog-data="currentDataId"
        @ok="confirmSemEditDialog"
        @close="closeSemEditDialog">
      </SemEditDialog>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import SemEditDialog from './SemEditDialog.vue';
import {datastatus_IE} from '../common';
export default {
  name: 'SemData',
  components: {
    SemEditDialog,
  },
  data() {
    return {
      searchParams: {
        startTime: '',
        endTime: '',
      },
      list: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      status_list:datastatus_IE,
      semForm:{
        sem_id:'',
        date_utc:'',
        date_mjd:'',
        hxmt_day:'',
        start_tt:'',
        stop_tt:'',
        duration:'',
        status:'',
        file_id:'',
        release_date:'',     
      },
      semIsVisible:false,
      SemEditIsVisible:false,
      currentDataId:null,
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      const params = {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        ...this.searchParams,
      }
      axios.post('/iapi/semsearch', params).then((res) => {
        if (res.data.errcode === 0) {
          this.total = res.data.data.total;
          this.list = res.data.data.list;
        }
      });
    },
    changePage(page) {
      this.currentPage = page;
      this.getData();
    },
    onSubmit() {
      this.currentPage = 1;
      this.getData();
    },
    sizeChange() {
      this.getData();
    },
    seminsert(){
      this.semIsVisible = true;
      this.semForm.sem_id = '';
      this.semForm.date_utc = '';
      this.semForm.date_mjd = '';
      this.semForm.hxmt_day = '';
      this.semForm.start_tt = '';
      this.semForm.stop_tt = '';
      this.semForm.duration = '';
      this.semForm.status = '';
      this.semForm.file_id = '';
      this.semForm.release_date = '';
    },
    closesemInsertDialog(){
      this.semIsVisible = false;
    },
    confirmsemInsertDialog(){
      this.closesemInsertDialog();
      const params = {
        ...this.semForm,
      };
      axios.post('/iapi/Seminsert', params).then((res) => {
        if (res.data.errcode === 0) {
          this.$message('新增SEM数据成功！');
        }
      });
      this.getData();
    },
    semDelete(DataID){
      const params = {
        data_id: DataID,
      };
      axios.post('/iapi/Semdelete', params).then((res) => {
        if (res.data.errcode === 0) {
          this.$message('删除SEM数据成功！');
        }
      });
      this.getData();
    },
    semEdit(dataId){
      this.SemEditIsVisible = true;
      this.currentDataId = dataId;
    },
    closeSemEditDialog(){
      this.SemEditIsVisible = false;
    },
    confirmSemEditDialog(data){
      this.closeSemEditDialog();
      const params = {
        sem_id:data.sem_id,
        date_utc:data.date_utc,
        date_mjd:data.date_mjd,
        hxmt_day:data.hxmt_day,
        start_tt:data.start_tt,
        stop_tt:data.stop_tt,
        duration:data.duration,
        status:data.status,
        file_id:data.file_id,
        release_date:data.release_date, 
        ind:data.ind,        
      }
      axios.post('/iapi/Semedit', params).then((res) => {
        if (res.data.errcode === 0) {
          this.$message('编辑SEM数据成功！');
        }
      });
      this.getData();    
    },
  },
};
</script>

<style scoped>

.sem-data {
  padding: 24px 56px;
}
.container {
  background: #fff;
  border-radius: 2px;
}
.search-form {
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 8px;
  padding-bottom: 8px;
}
.el-form-item {
    color: blue;
    margin-top: 0px;
    margin-bottom: 0px;
}
.admin-path {
  margin-bottom: 16px;
}
</style>